var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRouter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "903px",
    height: "903px",
    viewBox: "-0.5 -0.5 903 903",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-06-07T04:44:36.402Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.77 Safari/537.36\" version=\"14.7.6\" etag=\"pXbrLlZtyOYOcgWcG1Y9\"><diagram id=\"xdvizTvMO1GTcM4gcHgu\">jZTbbqMwEIafhtsI26GbXG5o9iBtpUq92GsXJmDVMMg4Cdmn3/EpgNquViGC+f7xYI9/k4mym74bObRPWIPOeF5PmXjMOBe8EHRz5BYI43sWSGNUHdkMXtQfiDCP9KxqGFeJFlFbNaxhhX0PlV0xaQxe12kn1Ou3DrKBd+Clkvo9/a1q2wa6419m/gNU06Y3s4d9UDqZkuNKxlbWeF0gccxEaRBteOqmErTrXupLGPftE/U+MQO9/Z8BPAy4SH2Oa4vzsre02AFVb33DigNd+abIeJn7f0F6SYy5KPLEQszW7MM8tvUk3RfKrij+IXklpXxQbzcrdInDBYxVtIm/5CvoZxyVVdjTul7RWuwoobWdppgtcr9q1bgciwNROQ7BTic1Qe1AlCtqNxgCvllgjhcIPXO1aI8H18tuatx52FRqrJDtN8bXOgzmZ+XnYfAcipyU1iVqNH4DBNuKhy13hazBN1goJ+l+pMRdpEnD9KkT2N1fdDIBO7DmRilpwDZaMh7KIsXX2eEij6xduPsOZTxVzb32bDx6iN5L4exxry0+FeL4Fw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 450,
    rx: 450,
    ry: 450,
    fill: "#004643",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 900,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 685.47 726.83 L 571.93 615.47 L 525.69 662.58 L 490.37 492.65 L 661.44 524.18 L 615.61 570.88 L 729.16 682.28 Z M 430.65 510.75 L 319.3 624.29 L 366.41 670.49 L 196.52 705.85 L 228 534.78 L 274.75 580.57 L 386.1 467.02 Z M 216.31 172.31 L 329.85 283.66 L 376.05 236.55 L 411.41 406.48 L 240.34 374.95 L 286.12 328.25 L 172.58 216.9 Z M 466.43 387.1 L 577.78 273.56 L 530.67 227.32 L 700.6 192 L 669.07 363.07 L 622.37 317.24 L 511.02 430.83 Z M 449.98 0 C 201.55 0 0 201.55 0 449.98 C 0 698.45 201.55 900 449.98 900 C 698.45 900 900 698.45 900 449.98 C 900 201.55 698.45 0 449.98 0 Z M 449.98 11.42 C 692.28 11.42 888.58 207.72 888.58 449.98 C 888.58 692.28 692.28 888.58 449.98 888.58 C 207.72 888.58 11.42 692.28 11.42 449.98 C 11.42 207.72 207.72 11.42 449.98 11.42 Z",
    fill: "#fafafa",
    stroke: "none",
    pointerEvents: "all"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouter);
export default __webpack_public_path__ + "static/media/router.848b4114f205c688b325d7529064a482.svg";
export { ForwardRef as ReactComponent };